module.exports = __webpack_public_path__ + "public/images/icons/chevron-down-gray.fd2a142eafc8f0215aa46a0ade58a2a8.svg";